export default __webpack_public_path__ + "static/media/pcarmshieldtop.10feae6b.png";